import { useQuery } from 'react-query';
import { QueryKey } from 'src/config/queryKey';
import { getAboutUsStaticPage } from 'src/common/services/staticPage';
import { StaticPageCode } from 'src/common/models/staticPage';

export const aboutUsStaticPageQueryKey = [QueryKey.StaticPage, StaticPageCode.AboutUs];

export const useAboutUsStaticPageQuery = () =>
  useQuery(aboutUsStaticPageQueryKey, () => getAboutUsStaticPage(), {
    cacheTime: Infinity,
    staleTime: Infinity,
  });
